import {
    all, put, takeLatest,
} from 'redux-saga/effects';

import {
    REJECT_ALL_FROM_BANNER,
    setCookieTimer,
    hideBanner,
    refuseAllCookies,
} from '../reduxModules/ConsentManagementPlatform';

export function* callAction() {
    yield all([
        put(hideBanner()),
        put(setCookieTimer()),
        put(refuseAllCookies()),
    ]);
}

export function* watch() {
    yield takeLatest(REJECT_ALL_FROM_BANNER, callAction);
}
